import { createReducer } from "@reduxjs/toolkit";
import {
    LoadingProductionHours,
    GetProductionWeekScheduleSuccess,
    SaveProductionWeekScheduleSuccess,
} from "./productionHoursAction";

export interface IProductionHoursState {
    productionWeekSchedule?: any;
    isLoading: boolean;
}

const initialState: IProductionHoursState = {
    productionWeekSchedule: null,
    isLoading: false,
};

export const productionHoursReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(LoadingProductionHours, (state, action) => {
            state.isLoading = action.payload;
        })
        .addCase(GetProductionWeekScheduleSuccess, (state, action) => {
            state.productionWeekSchedule = action.payload;
        })
        .addCase(SaveProductionWeekScheduleSuccess, (state, action) => {
            state.productionWeekSchedule = action.payload;
        });
});